import BaseHandler from "../BaseHandler";
import store from "../../store";

import { ChannelAvatarAdd, ChannelAvatarAddResponse } from "../../proto/ChannelAvatarAdd_pb";
import { editRoomExtra } from "../../store/rooms/actions";
import { addAvatars } from "../../store/avatars/actions";
import avatar from "../../components/shared/avatar";

export default class HandleChannelAddAvatarResponse extends BaseHandler<ChannelAvatarAddResponse, ChannelAvatarAdd> {
  handle() {
    const channelAddAvatarLinkResponse = this.response.toObject();
    if (channelAddAvatarLinkResponse !== undefined) {
      store.dispatch(
        editRoomExtra({
          channelRoomExtra: {
            avatar: channelAddAvatarLinkResponse.avatar,
          },
          roomId: channelAddAvatarLinkResponse.roomId,
        })
      );
      if (channelAddAvatarLinkResponse.avatar)
        store.dispatch(
          addAvatars({
            avatars: [channelAddAvatarLinkResponse.avatar],
            roomId: channelAddAvatarLinkResponse.roomId,
          })
        );
    }
  }
}
